module.exports = __webpack_public_path__ + "media/images/icons/flags/YE-92c1aaa1afcc9f0728d363464459c796.svg";